// import from react
import {
  StyledDrawerFooterInnerBox,
  StyledDrawerFooterMainBox
} from './DrawerFooter.styles';

// import types
import type { FC, PropsWithChildren } from 'react';

const DrawerFooter: FC<PropsWithChildren<object>> = ({ children }) => {
  return (
    <StyledDrawerFooterMainBox>
      <StyledDrawerFooterInnerBox>{children}</StyledDrawerFooterInnerBox>
    </StyledDrawerFooterMainBox>
  );
};

export default DrawerFooter;
